import { Controller as BaseController } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class Controller extends BaseController {
  static targets = ['dropdownTasks', 'dropdownEntity', 'dropdownReports'];

  connect() {
    useMatchMedia(this, {
      mediaQueries: {
        small: '(max-width: 576px)',
      },
    });

    // Remove any lingering hidden state when reconnecting
    this.element.classList.remove('tw-hidden');

    this.handleSidebarVisibility();
    this.updateActiveSection();

    // Bind handler for Turbo events
    this.boundHandleSidebarVisibility = this.handleSidebarVisibility.bind(this);

    // Listen to Turbo navigation events to update sidebar visibility
    document.addEventListener('turbo:load', this.boundHandleSidebarVisibility);
    document.addEventListener('turbo:render', this.boundHandleSidebarVisibility);
  }

  disconnect() {
    // Remove Turbo event listeners
    if (this.boundHandleSidebarVisibility) {
      document.removeEventListener('turbo:load', this.boundHandleSidebarVisibility);
      document.removeEventListener('turbo:render', this.boundHandleSidebarVisibility);
    }
  }

  handleSidebarVisibility() {
    if (this.shouldHideSidebar()) {
      this.hideSidebar();
    } else {
      this.showSidebar();
    }
  }

  shouldHideSidebar() {
    return (
      window.location.pathname.includes('scheduled_exams/response') ||
      window.location.pathname.match(/^\/socioeconomic\/new\/\d+$/) ||
      window.location.pathname.includes('learning_trail/activity')
    );
  }

  hideSidebar() {
    this.element.classList.add('tw-hidden');
  }

  showSidebar() {
    this.element.classList.remove('tw-hidden');
  }

  isSmall() {
    this.toggle();
  }

  toggle() {
    $('.sidebar').toggleClass('sidebar-expanded sidebar-collapsed');

    $('.sidebar-line-collapsed-hide').toggleClass('d-none');
    $('.sidebar-icon').toggleClass('fa-chevron-left fa-chevron-right');

    const sidebar = document.querySelector('.sidebar');
    const hasExpandend = sidebar.classList.contains('sidebar-expanded');

    if (hasExpandend) {
      $('.sidebar-nav-span').css('display', 'flex');
      $('.sidebar-nav-span-new').css('display', 'flex');
      $('.sidebar-collapsed-hide').css('display', 'block');
      $('.sidebar-education-toggle').css('display', 'block');
      $('.sidebar-img').removeClass('close-img-sidebar');
      $('.sidebar-close-mobile').removeClass('d-none');

      setTimeout(() => {
        $('.sidebar-nav-span').removeClass('sidebar-span-none');
        $('.sidebar-nav-span-new').removeClass('sidebar-span-none');
        $('.sidebar-collapsed-hide').removeClass('sidebar-span-none');
        $('.sidebar-education-toggle').removeClass('sidebar-span-none');
      }, 300);

      setTimeout(() => {
        $('.sidebar-nav-span').removeClass('sidebar-span-none');
        $('.sidebar-nav-span-new').removeClass('sidebar-span-none');
        $('.sidebar-collapsed-hide').removeClass('sidebar-span-none');
        $('.sidebar-education-toggle').removeClass('sidebar-span-none');
      }, 750);
    } else {
      $('.sidebar-nav-span').css('display', 'none');
      $('.sidebar-nav-span-new').css('display', 'none');
      $('.sidebar-collapsed-hide').css('display', 'none');
      $('.sidebar-education-toggle').css('display', 'none');
      $('.sidebar-img').addClass('close-img-sidebar');
      $('.sidebar-close-mobile').addClass('d-none');

      $('.sidebar-nav-span').addClass('sidebar-span-none');
      $('.sidebar-nav-span-new').addClass('sidebar-span-none');
      $('.sidebar-collapsed-hide').addClass('sidebar-span-none');
      $('.sidebar-education-toggle').addClass('sidebar-span-none');

      $('.sidebar-dropdown-new').removeClass('dropdown-open-two');
      $('.sidebar-dropdown-new').removeClass('dropdown-open-five');
      $('.sidebar-dropdown-new').addClass('dropdown-close');
    }
  }

  clickLink(event) {
    // Save active section to cookie and update UI
    const link = event.currentTarget;
    const sectionId = link.dataset.sectionId;
    if (sectionId) {
      this.setActiveSectionCookie(sectionId);
      this.updateActiveSection();
    }

    let width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 576) {
      this.toggle();
    }
  }

  setActiveSectionCookie(sectionId) {
    document.cookie = `active_sidebar_section=${sectionId}; path=/; max-age=${60 * 60 * 24 * 30}`; // 30 days
  }

  getActiveSectionCookie() {
    const name = 'active_sidebar_section=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  saveSection(event) {
    const section = event.currentTarget;
    const sectionId = section.dataset.sectionId;
    if (sectionId) {
      this.setActiveSectionCookie(sectionId);
      this.updateActiveSection();
    }
  }

  updateActiveSection() {
    const activeSectionId = this.getActiveSectionCookie();
    if (!activeSectionId) return;

    // Remove active-section class from all items
    const allSidebarItems = this.element.querySelectorAll('.sidebar-nav-list');
    allSidebarItems.forEach((item) => {
      item.classList.remove('active-section');
    });

    // Add active-section class to items matching the cookie
    const allLinks = this.element.querySelectorAll('a[data-section-id]');
    allLinks.forEach((link) => {
      if (link.dataset.sectionId === activeSectionId) {
        const navList = link.querySelector('.sidebar-nav-list');
        if (navList) {
          navList.classList.add('active-section');
        }
      }
    });

    // Check sections too
    const allSections = this.element.querySelectorAll(
      '.sidebar-nav-list[data-section-id], div[data-section-id]',
    );
    allSections.forEach((section) => {
      if (section.dataset.sectionId === activeSectionId) {
        if (section.classList.contains('sidebar-nav-list')) {
          section.classList.add('active-section');
        } else {
          // It's a div wrapper, find the parent li
          const parentLi = section.closest('.sidebar-nav-list');
          if (parentLi) {
            parentLi.classList.add('active-section');
          }
        }
      }
    });
  }

  toggleDropdownTasks(event) {
    let dropdownClass = 'dropdown-open-five';

    switch (event.params.quantity) {
      case 3:
        dropdownClass = 'dropdown-open-three';
        break;
      case 4:
        dropdownClass = 'dropdown-open-four';
        break;
    }

    if (this.dropdownTasksTarget.classList.contains('dropdown-close')) {
      this.dropdownTasksTarget.classList.replace('dropdown-close', dropdownClass);
    } else {
      this.dropdownTasksTarget.classList.replace(dropdownClass, 'dropdown-close');
    }
  }

  toggleDropdownReports(event) {
    let dropdownClass = 'dropdown-open-two';

    if (event.params.quantity === 1) {
      dropdownClass = 'dropdown-open-one';
    } else if (event.params.quantity === 3) {
      dropdownClass = 'dropdown-open-three';
    }

    if (this.dropdownReportsTarget.classList.contains('dropdown-close')) {
      this.dropdownReportsTarget.classList.replace('dropdown-close', dropdownClass);
    } else {
      this.dropdownReportsTarget.classList.replace(dropdownClass, 'dropdown-close');
    }
  }
}
